module.exports = __webpack_public_path__ + "img/NO917651817.1286494d.svg";